// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../shared/node_modules/css-loader/dist/cjs.js??ref--2-1!../../../../../../shared/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../shared/node_modules/postcss-loader/src/index.js!../../../../../../shared/node_modules/vue-loader/lib/index.js??vue-loader-options!./DisplayShortcutLinks.vue?vue&type=style&index=0&id=776e19a3&prod&scoped=true&lang=postcss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../shared/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2f3d5e0c", content, true, {});